import { useAppLogo } from "@features/exam/hooks/useAppLogo";
import { getQuestionMapItemState } from "@features/session/containers/StudySessionBottombarContainer/session-items-nav";
import { isIntroScreen } from "@features/session/helpers/intro-screens";
import { useAppStore } from "@hooks/useAppStore";
import type { QuestionMapItemState } from "@memorang/ui/components/QuestionMapItem";
import { useMemo } from "react";
import type useSessionAppBarState from "./useSessionAppBarState";

type SessionAppBarState = ReturnType<typeof useSessionAppBarState>;

const useTestDriverAppbarProps = (s: SessionAppBarState) => {
	const testDriver = useAppStore((state) => state.sessionView?.testDriver);
	const appLogo = useAppLogo().default;

	const isPteDriver = testDriver === "pte";
	const isToeicDriver = testDriver === "toeic";
	const isReadingSkill = s.skillName?.toLowerCase() === "reading";

	const toeicQuestionStates: QuestionMapItemState[] = useMemo(() => {
		const questionItems = s.currentBlock.filter((item) => !isIntroScreen(item));

		return questionItems.map((item) =>
			getQuestionMapItemState({
				item,
				itemStates: s.itemStates,
				answers: s.answers,
				inReviewMode: s.inReviewMode,
				currentItemId: s.currentItemId,
				itemViewedTimestamps: s.itemViewedTimestamps,
			}),
		);
	}, [
		s.answers,
		s.currentBlock,
		s.currentItemId,
		s.inReviewMode,
		s.itemStates,
		s.itemViewedTimestamps,
	]);

	return {
		isPteDriver,
		isToeicDriver,
		appLogo,
		toeicQuestionStates,
		hasListeningItems: s.hasListeningItems,
		isReadingSkill,
	};
};

export default useTestDriverAppbarProps;
